<template>
    <section id="bundleDetail" class="descriptionContainer">
        <button
            class="btn btn-block text-left descriptionButton"
            :class="{ collapsed: !isOpen }"
            :aria-expanded="isOpen ? 'true' : 'false'"
            aria-controls="bundleComponents"
            aria-label="Paketbestandteile anzeigen"
            click-count
            @click="toggleBundleComponents">
            <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="1.5" fill="none"
                stroke-linecap="round" stroke-linejoin="round" class="icon-bundle">
                <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
                <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                </path>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
            <span>In diesem Set enthalten</span>
            <i data-feather="plus"></i>
        </button>
 
        <div
            id="bundleComponents"
            class="collapse mt-1"
            :class="{ show: isOpen }"
            aria-labelledby="bundleComponents"
            data-parent="#rightSide">
            <loading-animation v-if="isLoading"></loading-animation>

            <div v-else-if="loadFailed" class="descriptionContent">
                Paketbestandteile konnten nicht geladen werden.
            </div>

            <div v-else-if="bundleComponents.length === 0" class="descriptionContent">
                Keine Paketbestandteile vorhanden.
            </div>

            <div
                v-for="bundleComponent in visibleBundleComponents"
                :key="getBundleComponentKey(bundleComponent)"
                class="bundleComponentItem">
                <category-item
                    :item-bundle-quantity="bundleComponent.quantity"
                    :item-data="bundleComponent.data"
                    :view-mode="'cart'">
                </category-item>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import ApiService from "../../services/ApiService";

export default {
    name: "single-item-bundle-details",

    props: {
        variationId: {
            type: Number,
            required: true
        }
    },

    data()
    {
        return {
            isOpen: false,
            bundleComponentsByVariationId: {},
            loadingVariationIds: {},
            failedVariationIds: {}
        };
    },

    computed: {
        bundleComponents()
        {
            return this.bundleComponentsByVariationId[this.variationId] || [];
        },

        visibleBundleComponents()
        {
            return this.bundleComponents.filter(bundleComponent =>
            {
                return !bundleComponent.data.texts.name1.includes("[");
            });
        },

        isLoading()
        {
            return !!this.loadingVariationIds[this.variationId];
        },

        loadFailed()
        {
            return !!this.failedVariationIds[this.variationId];
        },

        hasRequestedBundleComponents()
        {
            return Object.prototype.hasOwnProperty.call(this.bundleComponentsByVariationId, this.variationId);
        }
    },

    watch: {
        variationId()
        {
            this.isOpen = false;
        }
    },

    methods: {
        toggleBundleComponents()
        {
            this.isOpen = !this.isOpen;

            if (this.isOpen)
            {
                this.ensureBundleComponents();
            }
        },

        ensureBundleComponents()
        {
            if (this.hasRequestedBundleComponents || this.isLoading)
            {
                return;
            }

            Vue.set(this.loadingVariationIds, this.variationId, true);
            Vue.delete(this.failedVariationIds, this.variationId);

            ApiService.get(`/rest/io/variations/${this.variationId}/bundle-items`)
                .done(response =>
                {
                    const bundleComponents = this.normalizeBundleComponents(response);
                    Vue.set(this.bundleComponentsByVariationId, this.variationId, bundleComponents);
                })
                .fail(() =>
                {
                    Vue.set(this.failedVariationIds, this.variationId, true);
                })
                .always(() =>
                {
                    Vue.delete(this.loadingVariationIds, this.variationId);
                });
        },

        normalizeBundleComponents(response)
        {
            if (Array.isArray(response))
            {
                return response;
            }

            if (Array.isArray(response && response.documents))
            {
                return response.documents;
            }

            if (Array.isArray(response && response.data && response.data.documents))
            {
                return response.data.documents;
            }

            return [];
        },
        getBundleComponentKey(bundleComponent)
        {
            return `${bundleComponent.data.variation.id}-${bundleComponent.quantity}`;
        }
    }
};
</script>
